import React, { forwardRef } from 'react'
import { InputGroup, InputGroupText, Input } from 'reactstrap'
import { FormattedMessage } from 'react-intl'

import Checkbox from '~/components/Checkbox'

const OptionalField = (
  { name, label, value, placeholder, className, disabled, setDisabled },
  ref
) => {
  function handleChange(event) {
    setDisabled(!event.target.checked)
  }

  return (
    <div className={`w-100 ${className}`}>
      <label
        className="font-small-3 d-flex justify-content-between"
        htmlFor={name}
      >
        {label && <FormattedMessage id={label} />}{' '}
      </label>

      <InputGroup>
        <InputGroupText
          style={{
            maxHeight: '2.6rem',
            padding: '0.2rem 0.75rem',
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <Checkbox
            size="sm"
            onChange={handleChange}
            checked={!disabled}
            spanStyle={{ margin: 0 }}
          />
        </InputGroupText>
        <Input
          style={{ maxHeight: '2.6rem' }}
          ref={ref}
          name={name}
          value={value}
          disabled={disabled}
          placeholder={placeholder}
        />
      </InputGroup>
    </div>
  )
}

export default forwardRef(OptionalField)
